import { BfxBlotterOrdersContextMenuActionPayload } from "./BfxBlotterOrdersContextMenuActionPayload";
import { ContextMenuItemState } from "../ContextMenuItemState";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class BfxBlotterOrdersContextMenuItemRejectState extends ContextMenuItemState {
  public actionRequests: BfxBlotterOrdersContextMenuActionPayload;
  public callOrderRateSide?: CubiqTS.RateSideType = null;

  // copy from menu state
  public warnings = {
    show: false,
    warning_count: 0,
    external: {
      display: false,
      ids: [],
    },
  };

  constructor(
    count: number = 0,
    itemIndex: number = 0,
    available: boolean = false,
    enabled: boolean = false,
    title: string = "",
  ) {
    super(count, itemIndex, available, enabled, title);
  }
}
